<template>
  <span class="relative" v-if="planBenefit.abTest">
    <img
      src="@/assets/images/pro.svg"
      class="cursor-pointer ml-1 inline-block mb-1"
      :class="{'opacity-50': !noPermission }"
      v-tooltip="defaultTooltip"
      v-if="showDefaultTooltip"
    >
    <img
      src="@/assets/images/pro.svg"
      class="ml-1 inline-block mb-1"
      @click="openTooltip($event)"
      :class="{'opacity-50': !noPermission, 'cursor-pointer': noPermission }"
      v-else
    >
    <div class="upgrade-arrow upgrade-arrow_slide" v-if="isShowTooltip"></div>
    <PlanUpgradeTooltip
      v-if="isShowTooltip"
      @clickOutsideUpgrade="clickOutsideUpgrade"
      @openPlanUpgradeModal="openPlanUpgradeModal"
      :left="left"
    >
      <template #tooptip>
        <p v-if="defaultTooltip && typeof defaultTooltip === 'string'" class="default-tooltip">{{ defaultTooltip }}</p>
        <p
          v-if="defaultTooltip && defaultTooltip.content && defaultTooltip.html"
          class="default-tooltip"
          v-html="defaultTooltip.content"
        ></p>
        <span v-html="$i18nPresenter.t('upgradeMessagePricingTooltip', { upgradePlan })"></span>
      </template>
    </PlanUpgradeTooltip>
  </span>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import Util from '@/util'
import PlanUpgradeTooltip from '@/components-v2/presentation-editor/editor-header/PlanUpgradeTooltip.vue'
import eventCategories from '@/constant/eventCategories'

export default {
  name: 'IconNeedUpgradePlan',
  components: {
    PlanUpgradeTooltip,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    noPermission: {
      type: Boolean,
      default: false,
    },
    defaultTooltip: {
      type: [String, Object],
      default: () => '',
    },
    left: {
      type: String,
      default: '',
    },
    upgradePlan: {
      type: String,
      default: '',
    },
    featureName: {
      type: String,
      default: '',
    },
    source: {
      type: String,
      default: eventCategories.PRESENTATION_EDITOR,
    },
  },
  data() {
    return {
      isShowTooltip: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      planBenefit: (state) => state.planBenefit,
    }),
    showDefaultTooltip() {
      if (this.noPermission) return false
      if (!this.defaultTooltip) return false
      return true
    },
  },
  methods: {
    openTooltip(event) {
      if (event) {
        event.stopPropagation()
      }
      if (!this.noPermission) return
      this.isShowTooltip = true
    },
    toggleTooltip() {
      this.isShowTooltip = !this.isShowTooltip
    },
    clickOutsideUpgrade() {
      this.isShowTooltip = false
    },
    openPlanUpgradeModal() {
      this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
      Util.mixpanelTracking(
        this.source,
        'Feature upgrade',
        `${this.featureName}`,
        null,
        {
          presentationId: this.$store.state.presentation.id,
          userId: this.$store.state.currentUser.id,
          plan: this.$store.state.currentUser.plan,
        },
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.upgrade-arrow {
  width: 0;
  height: 0;
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent #282e3e transparent;
  border-style: solid;
  position: absolute;
  z-index: 1;
  top: 1.6rem;

  &.upgrade-arrow_presentation {
    left: calc(50% - 47px);
  }

  &.upgrade-arrow_slide {
    left: 30%;
  }
}
.default-tooltip {
  margin-bottom: 8px !important;
}
</style>
